module.exports = __webpack_public_path__ + "img/application3.bea64535.png";